module.exports = __webpack_public_path__ + "img/public/SiteIcons/expireIcon.svg?a64323eb";